import { ReactElement } from 'react';

import { Message, MessageType, StyledFlex } from '@dreryk/react-components';

import { PatientDataAccessMode } from '~libs.shared.prescription';

import { PatientDataAccessForm } from '../PatientDataAccessForm/PatientDataAccessForm';

import { PatientDataAccessDownloadHistoryButton } from './PatientDataAccessDownloadHistoryButton';
import { PatientDataAccessRequestStepLoader } from './PatientDataAccessRequestStep.loader';
import {
   OnPatientDataAccessApplicationVisitSuccess,
   onPatientDataAccessVerificationFault,
   PatientDataAccessSendDataAccessRequestButton,
} from './PatientDataAccessSendDataAccessRequestButton';

type PatientDataAccessRequestStepProps = {
   readonly patientId: number;
   readonly visitId: number;
   readonly errorMessage: string | undefined;
   readonly onPatientDataRequestSuccess: OnPatientDataAccessApplicationVisitSuccess;
   readonly onP1CommunicationFault: (faultDescription?: string) => void;
   readonly onPatientDataAccessVerificationFault: onPatientDataAccessVerificationFault;
   readonly onPatientIkpNotConfiguredFault: VoidFunction;
   readonly onPrescriptionHistoryDownloadRequest: (accessMode: PatientDataAccessMode | undefined) => void;
};

export const PatientDataAccessRequestStep = (props: PatientDataAccessRequestStepProps): ReactElement => {
   return (
      <PatientDataAccessRequestStepLoader patientId={props.patientId}>
         {({ authorizers, patient }) => (
            <StyledFlex gap={'8px'} direction={'column'}>
               {props.errorMessage ? (
                  <div>
                     <Message testId={'errorMessageStatus'} type={MessageType.NEGATIVE} label={props.errorMessage} />
                  </div>
               ) : null}
               <PatientDataAccessForm
                  patientAuthorizers={authorizers}
                  patientAge={patient.age!}
                  patientGender={patient.gender!}
               >
                  {({ handleSubmit, accessMode }) =>
                     accessMode === 'STANDARD' ? (
                        <PatientDataAccessSendDataAccessRequestButton
                           handleSubmit={handleSubmit}
                           onSuccess={props.onPatientDataRequestSuccess}
                           visitId={props.visitId}
                           onP1CommunicationFault={props.onP1CommunicationFault}
                           onPatientIkpNotConfiguredFault={props.onPatientIkpNotConfiguredFault}
                           onPatientDataAccessVerificationFault={props.onPatientDataAccessVerificationFault}
                        />
                     ) : (
                        <PatientDataAccessDownloadHistoryButton
                           onClick={() => props.onPrescriptionHistoryDownloadRequest(accessMode)}
                        />
                     )
                  }
               </PatientDataAccessForm>
            </StyledFlex>
         )}
      </PatientDataAccessRequestStepLoader>
   );
};
